export const equipmentpagetext = {
    displaymethod: "Affichage"
}

export const equipmenttext = {
    id: "Identifiant",
    name: "Nom",
    group: "Site",
    definition: "Type",
    fieldprotocol: "Protocole terrain",
    eosprotocol: "Type de connexion",
    lastconnection: "Dernière connexion",
    campaigngroup: "Emplacement dans une campagne",
    updategroupchoice: "Mise à jour du périmètre",
    hardware: "Modèle",
    undefinedhardware: "Non défini",
    unselectall: "Déselectionner tout",
    selectall: "Selectionner tout",
    yes: "Oui",
    no: "Non",
    included: "Inclus",
    includedlength: "Nombre d'équipements inclus",
    includedequipments: "Equipements inclus dans la GEB",
    iotbattery: "Batterie de l'IoT",
    iot: "IoT associé",
    iotsignal: "Puissance de signal",
    alarm: "Alarme",
    alarms: "Alarmes",
    noconnection: "Aucune connexion",
    activealarms: "Alarmes actives",
    nonacquitedalarms : "Alarmes fermées non acquitées",
    noalarms: "Aucune alarme en cours",
    subequipmentid: "Id de l'équipement sur l'IoT",
    equipmentcriticity: "Criticité de l'équipement",
}

export const pointtext = {
    id: "Identifiant",
    name: "Nom",
    session: "Session",
    state: "Etat",
    lastdate: "Date de dernière donnée",
    lastvalue: "Dernière valeur",
    equipment: "Equipement",
    group: "Site",
    definition: "Type",
    unit: "Unité",
    schedule: "Planning",
    controlmode: "Mode de pilotage",
    controlable: "Controlable",
    controlval: "Planning/Script/Valeur constante",
    value: "Valeur",
    eosprotocol: "Protocole de communication",
    url: "URL",
    modbustype: "Type d'équipement modbus",
    dataname: "Dataname LoRaWAN",
    fport: "FPort LoRaWAN",
    conversion: "Conversion",
    syncciteos: "Synchroniser avec Citeos",
    syncciteosname: "Nom de synchronisation",
    displayproperties: "Display properties",
    controlproperties: "Control properties",
    alarmproperties: "Alarm properties",
    livedata: "Méthode d'envoi des données",
}


export const equipmentalarmsstext = {
    id: "Id",
    name: "Nom",
    itemtype: "Type d'équipement",
    itemid: "Id équipement",
    alerttype: "Type d'alerte",
    osgroup: "Entité",
    criticity: "Criticité",
    starttimestamp: "Début de l'alerte",
    endtimestamp: "Fin de l'alerte",
    value: "Valeur",
    comments: "Commentaires",
    acquitment: "Acquittement",
    acquited: "Acquittée",
    closed: "Fermée",
    mailsent: "Mail envoyé",
    yes: "Oui ",
    no: "Non",
    noalerts: "Aucune alerte à afficher",
    delete: "Supprimer",
    deleted: "Alerte supprimée",
    nocomments: "Aucun",
    commentsvar: " commentaire(s)",
    warningacquitment: "Attention, acquitter l'alerte la cachera jusqu'à sa résolution.",
    confirmdelete: "Êtes-vous sûr de vouloir supprimer l'alerte?",
    deletealert: "Suppression de l'alerte",
    hideclosed: "Cacher les alertes fermées ou acquittées"
}
